export const validateNotWhitespaceOnly = (value: string) => {
  return !!value.trim()
}
